import ACTIONS from "../actions/types";

const initialState = {
  isFetchingUserAbility: false,
  allUsersList: [],
  // ability: [],
};
const usersReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ACTIONS.USERS.FETCH_USER_ABILITY_START:
      return {
        ...state,
        isFetchingUserAbility: true,
      };
    case ACTIONS.USERS.FETCH_USER_ABILITY_SUCCESS:
      return {
        ...state,
        isFetchingUserAbility: false,
        ability: Array.isArray(payload)
          ? payload.map(({ actions, action, ...rest }) => ({
              ...rest,
              action: action || (Array.isArray(actions) ? actions[0] : actions),
            }))
          : payload,
      };
    case ACTIONS.USERS.FETCH_USER_ABILITY_FAILURE:
      return {
        ...state,
        isFetchingUserAbility: false,
        errorMessage: payload,
      };

    case ACTIONS.USERS.FETCH_ALL_USER_START:
      return {
        ...state,
        allUsersList: [],
      };
    case ACTIONS.USERS.FETCH_ALL_USER_SUCCESS:
      return {
        ...state,
        allUsersList: [...payload],
      };
    case ACTIONS.USERS.FETCH_ALL_USER_FAILURE:
      return {
        ...state,
        allUsersList: [],
        errorMessage: payload,
      };

    default:
      return { ...state };
  }
};
export default usersReducer;
